export const ROLES = ['ADMIN', 'USER']